import { render, staticRenderFns } from "./SureLogo.vue?vue&type=template&id=13e5d636"
import script from "./SureLogo.vue?vue&type=script&lang=js"
export * from "./SureLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports